import { takeEvery, call, put } from 'redux-saga/effects';
import { apiPost } from '../core/dapi';
import { getClinicLeadsUrl } from '../core/dapi/clinicLeads';
import { clinicLeadSuccess, clinicLeadError } from '../actions/clinicLead';

const SUBMIT_CLINIC_LEAD_TO_SLACK = 'saga/SUBMIT_CLINIC_LEAD_TO_SLACK';

function* submitClinicLeadToSlack({ form }) {
  try {
    const clinicLeadsUrl = getClinicLeadsUrl();

    yield call(apiPost, clinicLeadsUrl, form);
    yield put(clinicLeadSuccess());
  } catch (e) {
    yield put(clinicLeadError(e.message));
  }
}

function* rootSaga() {
  yield takeEvery(SUBMIT_CLINIC_LEAD_TO_SLACK, submitClinicLeadToSlack);
}

export { SUBMIT_CLINIC_LEAD_TO_SLACK, rootSaga as default };
